import { MailSendConfig } from '@agent-ds/shared/components/mail-send/config';
import { StudentDetailConfig } from '@agent-ds/shared/components/mail-send/configs/student-detail-config';
import { StudentSendConfig } from '@agent-ds/shared/components/mail-send/configs/student-send-config';
import { Contract, CustomerList, DashboardType, ExpectedCompanyResponseDto, ProgressItemResponse, RaYomiProgressItem, ResponseStatus, SituationMemo, Student, StudentSituationMemo, Yomi3ProbabilityCalcResult } from '@agent-ds/shared/interfaces';
import { AmountRows, SalesAmount, SalesAmountForUser, SalesSummary, SalesSummaryForUser, SalesSummaryRow, TeamMonthlySalesOverviews, MonthlySalesOverview } from '@agent-ds/shared/interfaces/sale';
import {
  AuthService,
  CompanyApiService,
  CustomerApiService,
  CustomerExpectedCompanyYomiService,
  DialogService,
  DynamicFieldService,
  ExpectedCompanyTarget,
  ExportApiService,
  LayoutGlobalManagementHeaderVisibilityService,
  MasterApiService,
  SalesApiService,
  StudentApiService,
  UserApiService,
  Yomi3Target,
  YomiFormatedStudentSituationMemo,
  YomiFormatedStudentSituationMemoData,
} from '@agent-ds/shared/services';
import { cleanObject } from '@agent-ds/shared/util/util';
import { PROGRESS_STATUSES } from '@agent-ds/shared/constants';
import { UserTeamInjectorProvider } from '@agent-ds/shared/services/api/providers/user-team-injector.provider';
import { StudentTabs } from '@agent-ds/student/pages/student-detail-page/tabs/student-tabs';
import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CacheInterceptor } from '@agent-ds/shared/interceptors/cache.interceptor';

import { PageScrollTableComponent } from '../../page-scroll-table/page-scroll-table.component';
import {
  CustomerFilterCondition,
  CustomerFilterDefinition,
  CustomerFilterOption,
} from '../components/customer-filter-button-and-dialog/customer-filter-button-and-dialog.component';

import { DynamicField } from '@agent-ds/shared/models';
import * as moment from 'moment';
import * as _ from 'underscore';
import { GyosekiManagementCustomerProgressSkInfoDialogComponent } from '../components/gyoseki-management-customer-progress-sk-info-dialog/gyoseki-management-customer-progress-sk-info-dialog.component';
import { openStudentDetail, openStudentDetailMemo, openStudentMailSend } from '@agent-ds/shared/util/student-detail-actions';


@Component({
  selector: 'ag-global-gyoseki-management-header',
  templateUrl: './global-gyoseki-management-header.component.html',
  styleUrls: ['./global-gyoseki-management-header.component.scss'],
})
export class GlobalGyosekiManagementHeaderComponent implements OnInit, OnDestroy {
  private readonly RA_AGENT_TYPE = 1;
  @ViewChild(PageScrollTableComponent, { static: false }) table: PageScrollTableComponent;
  @ViewChild('customer', { static: false }) customerTemplate: TemplateRef<any>;
  @ViewChild('school', { static: false }) schoolTemplate: TemplateRef<any>;
  @ViewChild('graduateYear', { static: false }) graduateYearTemplate: TemplateRef<any>;
  @ViewChild('universityLevel', { static: false }) universityLevelTemplate: TemplateRef<any>;
  @ViewChild('sf', { static: false }) sfTemplate: TemplateRef<any>;
  @ViewChild('actions', { static: false }) actionsTemplate: TemplateRef<any>;
  @ViewChild('textfield', { static: false }) textfieldTemplate: TemplateRef<any>;

  @Output() readonly itemChecked = new EventEmitter<{ item?: any; checked: boolean }>();

  yomi3PassedDropdownData = [];
  yomi3InclinationDropdownData = [];
  yomi3ScheduleDropdownData = [];
  yomiDropdownData = [];
  expectedContractWeekDropdownData = [];
  sfDropdownData = [];

  weekTarget4w = {
    w1: {
      カタ: 1,
      FCST: 1,
      'FCST+': 8,
    },
    w2: {
      カタ: 1,
      FCST: 2,
      'FCST+': 8,
    },
    w3: {
      カタ: 2,
      FCST: 3,
      'FCST+': 6,
    },
    w4: {
      カタ: 4,
      FCST: 4,
      'FCST+': 4,
    },
  };

  readonly weekTarget5w = {
    w1: {
      カタ: 0,
      FCST: 1,
      'FCST+': 6,
    },
    w2: {
      カタ: 1,
      FCST: 2,
      'FCST+': 8,
    },
    w3: {
      カタ: 2,
      FCST: 2,
      'FCST+': 8,
    },
    w4: {
      カタ: 3,
      FCST: 3,
      'FCST+': 6,
    },
    w5: {
      カタ: 4,
      FCST: 4,
      'FCST+': 4,
    },
  };

  readonly defaultSalesForUserModel = {
    ca: {
      sn: 0,
      snAg: 0,
      snPlus: 0,
      sk: 0,
      skAg: 0,
      skPlus: 0,
      cancelSn: 0,
      cancelSnAg: 0,
      cancelSnPlus: 0,
      cancel: 0,
      cancelAg: 0,
      cancelPlus: 0,
    },
    rapa: {
      sn: 0,
      snAg: 0,
      snPlus: 0,
      sk: 0,
      skAg: 0,
      skPlus: 0,
      cancelSn: 0,
      cancelSnAg: 0,
      cancelSnPlus: 0,
      cancel: 0,
      cancelAg: 0,
      cancelPlus: 0,
    }
  };
  readonly defaultSalesForTeamModel: SalesAmount = {
    ca: {
      users: [],
      total: {
        sn: 0,
        snAg: 0,
        snPlus: 0,
        sk: 0,
        skAg: 0,
        skPlus: 0,
        cancelSn: 0,
        cancelSnAg: 0,
        cancelSnPlus: 0,
        cancel: 0,
        cancelAg: 0,
        cancelPlus: 0,
      }
    },
    rapa: {
      users: [],
      total: {
        sn: 0,
        snAg: 0,
        snPlus: 0,
        sk: 0,
        skAg: 0,
        skPlus: 0,
        cancelSn: 0,
        cancelSnAg: 0,
        cancelSnPlus: 0,
        cancel: 0,
        cancelAg: 0,
        cancelPlus: 0,
      }
    }
  };
  readonly defaultSalesSummaryForUserModel = {
    ca: {},
    rapa: {}
  };
  readonly defaultSalesSummaryForTeamModel: SalesSummary = {
    ca: {
      users: {},
      total: {}
    },
    rapa: {
      users: {},
      total: {}
    }
  };
  readonly MGR_DISPLAY_DASHBOARD_TYPES = [DashboardType.CA_Manager];

  enterprises = [];
  studentTabs = {
    OVERVIEW: 0,
    DETAIL: 1,
    ACADEMIC: 2,
    PREFERENCES: 3,
    PROGRESS: 4,
    CONTACTS: 5,
    MESSAGE: 6,
    MEMO: 7,
    FILES: 8,
    SEMINARS: 9,
    MATCHES: 10,
  };

  detailConfig = new StudentDetailConfig();
  sendConfig = new StudentSendConfig();

  tabs = StudentTabs;
  initialized = false;
  userNameSortStatus = 'asc';
  yomiSortStatus = 'asc';
  activeSortStatus = 'asc';
  progressSortStatus = 'asc';
  sfSortStatus = 'asc';
  yomi3PassedSortStatus = 'asc';
  yomi3InclinationSortStatus = 'asc';
  yomi3ScheduleSortStatus = 'asc';
  graduateYearSortStatus = 'asc';
  pickUpMemoRegisterSortStatus = 'asc';

  get checkedItems(): Student[] {
    return this.table ? this.table.checkedItems : [];
  }

  get allChecked(): boolean {
    return this.table.allChecked;
  }

  get totalSize(): number {
    return this.table.totalSize;
  }

  init = false;
  isHeaderOpen = false;
  isHeaderOpenSubscriber?: Subscription = null;
  loadingCustomer = false;
  loginSubscription?: Subscription = null;
  studentsRefreshSubscription?: Subscription = null;
  customerApiRefreshSubscription?: Subscription = null;
  dynamicFieldSubscription?: Subscription = null;

  // customers: Customer[] = [];
  customers: Student[] = [];
  customerTotal = 0;

  // Original Customer Expected Company List Collection
  customersExpectedCompanyListMapping: Record<number, ExpectedCompanyResponseDto[]> = {};
  // Formatted list of expected companies for UI display
  customersExpectedCompanyUIList: Record<string, {label: string, value: number}[]> = {};
  // Expected Company 1 Mappings
  customersExpectedCompanyProgressIdMapping: Record<number, number> = {};
  customersExpectedCompanyMapping: Record<number, ExpectedCompanyResponseDto> = {};
  // Expected Company 2 Mappings
  customersExpectedCompany2ProgressIdMapping: Record<number, number> = {};
  customersExpectedCompany2Mapping: Record<number, ExpectedCompanyResponseDto> = {};
  // Exposing the ExpectedCompanyTarget enum to HTML side
  ExpectedCompanyTarget = ExpectedCompanyTarget;
  // Exposing the Yomi3Target enum to HTML side
  Yomi3Target = Yomi3Target;
  customerRaYomiProgressMapping: Record<number, RaYomiProgressItem[]> = {};

  pickUpMemo: Record<number, YomiFormatedStudentSituationMemo> = {};
  salesForUserModel: SalesAmountForUser = this.defaultSalesForUserModel;
  salesSummaryForUserModel: SalesSummaryForUser = this.defaultSalesSummaryForUserModel;
  salesForTeamModel: SalesAmount = this.defaultSalesForTeamModel;
  salesSummaryForTeamModel: SalesSummary = this.defaultSalesSummaryForTeamModel;

  // Contracted Month Configurations
  // How many month ahead can be selected
  expectedContractMonthConfigAhead = 3;
  // How many month behind can be selected
  expectedContractMonthConfigBehind = 12;
  // The properties that stores and updates the input's value, min, and max.
  expectedContractMonthMinOption: string;
  expectedContractMonthMaxOption: string;
  selectedExpectedContractMonthValue: string;

  expectedContractWeeklyValue: string;
  expectedContractWeeklyInputWidth: number;
  userHasManagementRole = false;
  selectedManagementTeamId?: number = null;
  customerFilterConditions: CustomerFilterCondition[] = [];
  private userNameMap: Record<number, string> = {};

  currentPage: number = 1;
  readonly pageSize: number = 50;
  totalFilteredCount: number = 0;
  displayedCustomers: Student[] = [];
  teamUsers: { id: number; name: string }[] = [];

  constructor(
    protected router: Router,
    protected activeRoute: ActivatedRoute,
    protected location: Location,
    protected exportService: ExportApiService,
    private dynamicService: DynamicFieldService,
    private dialog: DialogService,
    private authService: AuthService,
    private customerApiService: CustomerApiService,
    private companyApiService: CompanyApiService,
    public readonly masterService: MasterApiService,
    public readonly userService: UserApiService,
    public readonly userTeamInjector: UserTeamInjectorProvider,
    public readonly fb: FormBuilder,
    private managementTableVisibility: LayoutGlobalManagementHeaderVisibilityService,
    private expectedCompanyYomiService: CustomerExpectedCompanyYomiService,
    private studentService: StudentApiService,
  ) {
    // Create the initial data of the contracted month date filter.
    const now = moment();
    this.selectedExpectedContractMonthValue = moment().format('YYYY-MM');
    this.expectedContractMonthMinOption = now
      .clone()
      .subtract(this.expectedContractMonthConfigBehind, 'months')
      .format('YYYY-MM');
    this.expectedContractMonthMaxOption = now
      .clone()
      .add(this.expectedContractMonthConfigAhead, 'months')
      .format('YYYY-MM');
  }

  ngOnInit() {
    this.loginSubscription = this.authService.isLogined().subscribe((logined) => {
      if (logined) {
        this.userHasManagementRole = this.MGR_DISPLAY_DASHBOARD_TYPES.includes(
          this.authService.loginUser.dashboardType
        );
        this.selectedManagementTeamId = this.userHasManagementRole && this.authService.loginUser.managementTeams.length > 0 && this.authService.loginUser.managementTeams[0].id;
        this.userService.getAll().subscribe((users) => {
          this.userNameMap = users.reduce((result, user) => {
            result[user.id] = user.name || '';
            return result;
          }, {});
        });
      }
    });
    this.dynamicFieldSubscription = this.dynamicService.fieldUpdateEvent.subscribe(() => {
      const makeDdFieldDropdownData = (ddField: DynamicField): { label: string; value: string }[] => {
        if (
          !ddField ||
          !ddField.validationStyle ||
          !Array.isArray(ddField.validationStyle.options) ||
          ddField.validationStyle.options.length === 0
        ) {
          throw new Error('ddField is not valid for making list');
        }
        return [
          { label: '-----', value: null },
          ...ddField.validationStyle.options.map((option) => ({ label: option, value: option }))
        ];
      };
      this.yomiDropdownData = makeDdFieldDropdownData(this.dynamicService.getDefinition('student', 'yomi'));
      this.expectedContractWeekDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('student', 'expectedContractWeek'),
      );
      this.yomi3PassedDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'yomi3Passed'),
      );
      this.yomi3InclinationDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'yomi3Inclination'),
      );
      this.yomi3ScheduleDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('progress', 'yomi3Schedule'),
      );
      this.sfDropdownData = makeDdFieldDropdownData(
        this.dynamicService.getDefinition('student', 'rank'),
      );
    });

    this.updateDisplayForExpectedContractWeekly();

    this.studentsRefreshSubscription = this.studentService.refreshEvent.subscribe(() => {
      // this.handleUpdateFilter();
    });

    this.customerApiRefreshSubscription = this.customerApiService.refreshEvent.subscribe(() => {
      // this.handleUpdateFilter();
    });

    this.isHeaderOpenSubscriber = this.managementTableVisibility.gyosekiManagementVisible$.subscribe((value) => {
      this.isHeaderOpen = value;
    });
  }

  ngOnDestroy() {
    if (this.isHeaderOpenSubscriber) {
      this.isHeaderOpenSubscriber.unsubscribe();
      this.isHeaderOpenSubscriber = null;
    }

    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
      this.loginSubscription = null;
    }

    if (this.studentsRefreshSubscription) {
      this.studentsRefreshSubscription.unsubscribe();
      this.studentsRefreshSubscription = null;
    }

    if (this.customerApiRefreshSubscription) {
      this.customerApiRefreshSubscription.unsubscribe();
      this.customerApiRefreshSubscription = null;
    }
    if (this.dynamicFieldSubscription) {
      this.dynamicFieldSubscription.unsubscribe();
      this.dynamicFieldSubscription = null;
    }
  }
  updateTableDataWithTeamId(newTeamId: number): void {
    if(newTeamId) {
      this.selectedManagementTeamId = newTeamId;
      this.loadHeaderDataWithTeamSearch({
        teamId: newTeamId
      });
    } else {
      this.selectedManagementTeamId = null;
      this.loadHeaderDataForCurrentUser(this.authService.loginUser.id);
    }
  }
  handleYomi3Change(studentId: number, yomi3Target: Yomi3Target) {
    const expectedCompany = this.customersExpectedCompanyMapping[studentId];
    this.expectedCompanyYomiService.handleYomi3Change({
      studentId,
      expectedCompany,
      yomi3Target
    }).subscribe(async() => {
      setTimeout(() => {
        this.expectedCompanyYomiService.callCalculateApiForYomi3Probability(expectedCompany).subscribe((result) => {
          expectedCompany.yomi3ProbabilityCalcResult = result;
        });
      }, 0);
    });
  }

  handlerYomiTypeChange(studentId: number) {
    this.expectedCompanyYomiService.handlerYomiTypeChange(studentId, this.customers)
      .subscribe(() => {
        // this.studentService.refreshEvent.emit();
      });
  }

  handleUpdateFilter() {
    if(this.selectedManagementTeamId) {
      this.loadHeaderDataWithTeamSearch({teamId: this.selectedManagementTeamId });
    } else {
      this.loadHeaderDataForCurrentUser(this.authService.loginUser.id);
    }
  }

  handleCaExpectedSKUpdate(studentId: number, expectedSk: number) {
    this.expectedCompanyYomiService
      .handleExpectedSKUpdate(
        studentId,
        this.customersExpectedCompanyProgressIdMapping[studentId],
        expectedSk
      )
      .subscribe((res) => this.customerApiService.refreshEvent.emit());
  }

  getYearMonthFromDateString(dateString) {
    return this.expectedCompanyYomiService.getYearMonthFromDateString(dateString);
  }

  handleUpdateExpectedContractMonth($event, student: Student) {
    this.expectedCompanyYomiService
      .handleUpdateExpectedContractMonth($event.target.value, student)
      .subscribe((res) => this.customerApiService.refreshEvent.emit());
  }

  handleUpdateExpectedContractWeek(student: Student) {
    this.customerApiService.updateExpectedContractWeek(
      student.id,
      student.dynamicData.expectedContractWeek
    ).subscribe(
      (res) => this.customerApiService.refreshEvent.emit()
    );
  }

  handleShowCaExpectedSKInfoDialog(studentId: number) {
    if(!this.customersExpectedCompanyProgressIdMapping[studentId] || !this.customersExpectedCompanyMapping[studentId]) {
      return;
    }
    // progress => job_id を取得
    // job => enterprise_department => enterprise => contracts を取得
    this.companyApiService.getContractsRelatedToJob(
      this.customersExpectedCompanyMapping[studentId].j_id
    ).subscribe((contracts: Contract[]) => {
      this.dialog.open(
        GyosekiManagementCustomerProgressSkInfoDialogComponent,
        {
          data: { contracts },
        }
      );
    });
  }

  get customerFilterDefinitions(): CustomerFilterDefinition[] {
    return [
      ...(this.selectedManagementTeamId
        ? [{
            key: 'userName',
            label: 'ユーザー名',
            type: 'select' as const,
            options: this.teamUsers.map((user) => ({ label: user.name, value: user.id })),
          }]
        : []),
      {
        key: 'yomi',
        label: 'ヨミ',
        type: 'select',
        options: this.makeDropdownOptions(this.yomiDropdownData),
      },
      {
        key: 'activeCount',
        label: '稼働',
        type: 'number',
      },
      {
        key: 'progressCount',
        label: '進捗',
        type: 'number',
      },
      {
        key: 'sf',
        label: 'SF',
        type: 'select',
        options: this.makeDropdownOptions(this.sfDropdownData),
      },
      {
        key: 'graduateYear',
        label: '卒業年',
        type: 'select',
        options: this.buildSelectOptions((() => {
          const maxYear = new Date().getFullYear() + 2;
          return Array.from(
            { length: maxYear - 1990 + 1 },
            (_, i) => String(maxYear - i),
          );
        })()),
      },
      {
        key: 'yomi3Passed',
        label: '3軸ヨミ(合格)',
        type: 'select',
        options: this.makeDropdownOptions(this.yomi3PassedDropdownData),
      },
      {
        key: 'yomi3Inclination',
        label: '3軸ヨミ(意向)',
        type: 'select',
        options: this.makeDropdownOptions(this.yomi3InclinationDropdownData),
      },
      {
        key: 'yomi3Schedule',
        label: '3軸ヨミ(日程)',
        type: 'select',
        options: this.makeDropdownOptions(this.yomi3ScheduleDropdownData),
      },
    ];
  }

  handleSaveMemo(studentId:number, memo: YomiFormatedStudentSituationMemo) {
    this.expectedCompanyYomiService.handleSaveMemo(studentId, memo, this.authService.loginUser)
      .subscribe(() => {
        this.customerApiService.refreshEvent.emit();
      });
  }
  handleChangeExpectedCompany(studentId: number, newExpectedCompany: number): void {
    this.expectedCompanyYomiService.updateCustomerExpectedCompany(
      studentId,
      newExpectedCompany,
      this.customersExpectedCompanyListMapping
    ).subscribe((responseStatus: ResponseStatus) => {
        if (responseStatus.status) {
          const expectedData = this.customersExpectedCompanyListMapping[studentId].find(
            ec => ec.p_id === Number(newExpectedCompany)
          );

          this.updateExpectedCompanyMappings(ExpectedCompanyTarget.Company1, studentId, expectedData);
        }
      });
  }

  handleChangeExpectedCompany2(studentId: number, newExpectedCompany: number): void {
    this.expectedCompanyYomiService.updateCustomerExpectedCompany2(
      studentId,
      newExpectedCompany,
      this.customersExpectedCompanyListMapping
    ).subscribe((responseStatus: ResponseStatus) => {
        if (responseStatus.status) {
          const expectedData = this.customersExpectedCompanyListMapping[studentId].find(
            ec => ec.p_id === Number(newExpectedCompany)
          );

          this.updateExpectedCompanyMappings(ExpectedCompanyTarget.Company2, studentId, expectedData);
        }
      });
  }

  updateExpectedCompanyMappings(target: ExpectedCompanyTarget | string, studentId: number, expectedData: ExpectedCompanyResponseDto | null) {
    if(target === ExpectedCompanyTarget.Company1) {
      if (expectedData) {
        expectedData.yomi3ProbabilityCalcResult = this.expectedCompanyYomiService.makeYomi3ProbabilityDataFrom(expectedData);
        this.customersExpectedCompanyProgressIdMapping[studentId] = expectedData.p_id;
        this.customersExpectedCompanyMapping[studentId] = expectedData;
      } else {
        this.customersExpectedCompanyProgressIdMapping[studentId] = 0;
        this.customersExpectedCompanyMapping[studentId] = {};
      }
    } else if (target === ExpectedCompanyTarget.Company2) {
      if (expectedData) {
        this.customersExpectedCompany2ProgressIdMapping[studentId] = expectedData.p_id;
        this.customersExpectedCompany2Mapping[studentId] = expectedData;
      } else {
        this.customersExpectedCompany2ProgressIdMapping[studentId] = 0;
        this.customersExpectedCompany2Mapping[studentId] = {};
      }
    }
  }

  updateDisplayForExpectedContractWeekly() {
    const currentWeekKey = `w${this.expectedCompanyYomiService.currentWeekTarget()}`;
    const currentWeeklyData = this.expectedCompanyYomiService.isCurrentMonth5WeekTarget() ? this.weekTarget5w[currentWeekKey] : this.weekTarget4w[currentWeekKey];

    this.expectedContractWeeklyValue = Object.entries(currentWeeklyData)
      .map(([key, value]) => `${key}: ${value}`)
      .join(' | ');
  }

  processCustomerListResponse(customerList: CustomerList) {
    this.customers = this.expectedCompanyYomiService.getDefaultSortedCustomers(customerList.students);
    this.customerTotal = customerList.total;
    this.teamUsers = customerList.users || [];
    this.customerRaYomiProgressMapping = this.buildCustomerRaYomiProgressMapping(customerList.progresses);
    this.customersExpectedCompanyListMapping = customerList.expectedCompanies;
    Object.keys(this.customersExpectedCompanyListMapping).forEach(studentId => {
      this.customersExpectedCompanyUIList[studentId] =
        this.expectedCompanyYomiService.makeCustomersExpectedCompanyUIList(
          this.customersExpectedCompanyListMapping[studentId]
        );

      // Update Expected Company 1 & 2 Mappings
      for (const targetKey in ExpectedCompanyTarget) {
        // console.log(targetKey);
        const expectedCompanyTarget = ExpectedCompanyTarget[targetKey];
        const foundExpectedCompany: ExpectedCompanyResponseDto = this.customersExpectedCompanyListMapping[studentId].find(
          expectedCompany => Number(expectedCompany[expectedCompanyTarget]) === 1
        );
        this.updateExpectedCompanyMappings(expectedCompanyTarget, Number(studentId), foundExpectedCompany);
      }

      // Memo Logic
      const customer = this.customers.find((cus) => cus.id === Number(studentId));
      this.pickUpMemo[studentId] = this.expectedCompanyYomiService
        .pickTop1StudentSituationMemoWithSortAndFormat(
          customer ? customer.studentSituationMemo : undefined
        );
    });
    this.currentPage = 1;
    this.updateDisplayedCustomers();
  }

  private buildCustomerRaYomiProgressMapping(
    progresses: ProgressItemResponse[] = [],
  ): Record<number, RaYomiProgressItem[]> {
    return progresses.reduce((mapping, progress) => {
      const studentId = progress.studentId;
      const progressUsers = progress.progressUsers || [];
      const raProgressUser = progressUsers.find(
        (progressUser) => progressUser.type === this.RA_AGENT_TYPE,
      );
      const progressDynamicData = progress.dynamicData || {};
      const progressJob = (progress as any).job || {};
      const enterpriseDepartment = progressJob.enterpriseDepartment || {};
      const jobEnterprise = enterpriseDepartment.enterprise || {};
      const jobEnterpriseDynamicData = jobEnterprise.dynamicData || {};
      const progressEnterprise = (progress as any).enterprise || {};
      const raUserName =
        raProgressUser && raProgressUser.user ? raProgressUser.user.name : '';

      if (!mapping[studentId]) {
        mapping[studentId] = [];
      }

      mapping[studentId].push({
        progressId: progress.id,
        raUserName,
        raYomi: progressDynamicData.raYomi || '',
        targetMonth: this.formatRaTargetMonth(
          progressDynamicData.raExpectedContractMonth,
        ),
        enterpriseName:
          jobEnterpriseDynamicData.name || jobEnterprise.name || progressEnterprise.name || '',
        yomi3Text: this.formatRaYomi3Text(progress),
        probabilityLabel: progressDynamicData.raYomi3ProbabilityResultLabel || '',
        probability: Number(progressDynamicData.raYomi3ProbabilityResult) || 0,
      });

      return mapping;
    }, {} as Record<number, RaYomiProgressItem[]>);
  }

  private formatRaTargetMonth(targetMonth?: string): string {
    if (!targetMonth) {
      return '';
    }

    const parsed = moment(targetMonth, ['YYYY-MM-DD', 'YYYY-MM'], true);
    return parsed.isValid() ? parsed.format('YYYY年M月') : targetMonth;
  }

  private formatRaYomi3Text(progress: ProgressItemResponse): string {
    const progressDynamicData = progress.dynamicData || {};

    return [
      progressDynamicData.raYomi3Passed,
      progressDynamicData.raYomi3Inclination,
      progressDynamicData.raYomi3Schedule,
    ]
      .filter((value) => !!value)
      .join('×');
  }

  processSalesReportResponse(salesAmountForUser: SalesAmountForUser) {
    if(salesAmountForUser.ca) {
      this.salesForUserModel = salesAmountForUser;
    } else {
      this.salesForUserModel = this.defaultSalesForUserModel;
    }
  }

  processSalesSummaryForUser(salesAmountForUser: SalesAmountForUser, monthlySalesOverview: MonthlySalesOverview) {
    this.salesSummaryForUserModel = this.expectedCompanyYomiService.doCalculateSalesSummaryForUser(
      salesAmountForUser,
      monthlySalesOverview
    );
  }

  processTeamSalesReportResponse(salesAmount: SalesAmount) {
    if(salesAmount.ca) {
      this.salesForTeamModel = salesAmount;
    } else {
      this.salesForTeamModel = this.defaultSalesForTeamModel;
    }
  }
  processTeamSalesSummary(salesAmount: SalesAmount, teamMonthlySalesOverviews: TeamMonthlySalesOverviews ) {
    if(salesAmount.ca || teamMonthlySalesOverviews) {
      this.salesSummaryForTeamModel = this.expectedCompanyYomiService.doCalculateSalesSummaryForTeam(
        salesAmount,
        teamMonthlySalesOverviews,
      );
    } else {
      this.salesSummaryForTeamModel = this.defaultSalesSummaryForTeamModel;
    }
  }

  loadHeaderDataForCurrentUser(userId) {
    this.loadingCustomer = true;
    CacheInterceptor.incrementCount();
    const filterParams = this.buildApiFilterParams(this.customerFilterConditions);

    forkJoin([
        this.expectedCompanyYomiService.fetchMySalesTargetCustomerList(this.selectedExpectedContractMonthValue, filterParams),
        this.expectedCompanyYomiService.fetchMySalesReport(this.selectedExpectedContractMonthValue),
        this.expectedCompanyYomiService.fetchMyMonthlySalesOverview(this.selectedExpectedContractMonthValue),
      ]).pipe(
        finalize(() => {
          this.loadingCustomer = false;
          CacheInterceptor.decrementCount();
        }),
      ).subscribe({
        next: ([customerList, salesAmountForUser, monthlySalesOverview]: [CustomerList, SalesAmountForUser, MonthlySalesOverview]) => {
          this.processCustomerListResponse(customerList);
          this.processSalesReportResponse(salesAmountForUser);
          this.processSalesSummaryForUser(
            salesAmountForUser,
            monthlySalesOverview
          );
        },
      });
  }

  loadHeaderDataWithTeamSearch({ teamId }: { teamId?: number}  = {} ) {
    this.loadingCustomer = true;
    CacheInterceptor.incrementCount();
    const filterParams = this.buildApiFilterParams(this.customerFilterConditions);

    forkJoin([
        this.expectedCompanyYomiService.fetchTeamSalesTargetCustomerList(teamId, this.selectedExpectedContractMonthValue, filterParams),
        this.expectedCompanyYomiService.fetchTeamSalesReport(teamId, this.selectedExpectedContractMonthValue),
        this.expectedCompanyYomiService.fetchTeamMonthlySalesOverviews(teamId, this.selectedExpectedContractMonthValue),
      ]).pipe(
        finalize(() => {
          this.loadingCustomer = false;
          CacheInterceptor.decrementCount();
        }),
      ).subscribe({
        next: ([customerList, salesAmount, teamMonthlySalesOverviews]: [CustomerList, SalesAmount, TeamMonthlySalesOverviews]) => {
          this.processCustomerListResponse(customerList);
          this.processTeamSalesReportResponse(salesAmount);
          this.processTeamSalesSummary(salesAmount, teamMonthlySalesOverviews);
        },
      });
  }

  toggleGlobalGyosekiManagementHeader(): void {
    this.managementTableVisibility.toggleGlobalGyosekiManagementHeader();

    if (this.isHeaderOpen) {
      this.customerFilterConditions = [];
      this.handleUpdateFilter();
    }
  }

  openChat(lineId): void {
    return this.expectedCompanyYomiService.openChat(lineId);
  }

  handlerGraduateYearView(year): string {
    return this.expectedCompanyYomiService.handlerGraduateYearView(year);
  }

  handlerDateMonthDayPlusjp(dateData) {
    return this.expectedCompanyYomiService.handlerDateMonthDayPlusjp(dateData);
  }

  // ES は日付を UTC で保存するため、JST 表示に補正する (+9h)
  toJstDateStr(dateVal: any): string {
    if (!dateVal) {
      return '';
    }
    const ms = new Date(dateVal as string).getTime() + 9 * 60 * 60 * 1000;
    return new Date(ms).toISOString().slice(0, 10);
  }

  onItemSelect(selectedItem: any): void {
    openStudentDetail(selectedItem);
  }

  onItemSelectAndMemo(selectedItem: any): void {
    openStudentDetailMemo(selectedItem);
  }

  openMailSend(config: MailSendConfig = this.detailConfig, student): void {
    openStudentMailSend(config, student);
  }

  handlerExpectedCompanyTypeView(type: number): string {
    return this.expectedCompanyYomiService.handlerExpectedCompanyTypeView(type);
  }

  handlerProgressStatusView(expectedCompany: ExpectedCompanyResponseDto): string {
    return this.expectedCompanyYomiService.handlerProgressStatusView(expectedCompany, PROGRESS_STATUSES);
  }

  handleCustomerFilterChange(conditions: CustomerFilterCondition[]): void {
    this.customerFilterConditions = conditions;
    this.currentPage = 1;
    this.handleUpdateFilter();
  }

  handlerUserNameSort() {
    if (this.userNameSortStatus === 'asc') {
      this.userNameSortStatus = 'desc';
      this.customers.sort((a, b) => this.compareUserNameOrder(a, b));
      this.updateDisplayedCustomers(true);
      return;
    }

    this.userNameSortStatus = 'asc';
    this.customers.sort((a, b) => this.compareUserNameOrder(b, a));
    this.updateDisplayedCustomers(true);
  }

  handlerYomiSort() {
    if (this.yomiSortStatus === 'asc') {
      this.yomiSortStatus = 'desc';
      this.customers.sort((a, b) =>
        this.compareYomiOrder(a && a.dynamicData ? a.dynamicData.yomi : undefined, b && b.dynamicData ? b.dynamicData.yomi : undefined)
      );
      this.updateDisplayedCustomers(true);
      return;
    }

    this.yomiSortStatus = 'asc';
    this.customers.sort((a, b) =>
      this.compareYomiOrder(b && b.dynamicData ? b.dynamicData.yomi : undefined, a && a.dynamicData ? a.dynamicData.yomi : undefined)
    );
    this.updateDisplayedCustomers(true);
  }

  handlerActiveSort() {
    if (this.activeSortStatus === 'asc') {
      this.activeSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.activeCount || a.activeCount > b.activeCount) {
          return -1;
        }
        if (a.activeCount < b.activeCount) {
          return 1;
        }
        return 0;
      });
      this.updateDisplayedCustomers(true);
      return;
    }

    this.activeSortStatus = 'asc';
    this.customers.sort((a, b) => {
      if (!a.activeCount || a.activeCount < b.activeCount) {
        return -1;
      }
      if (a.activeCount > b.activeCount) {
        return 1;
      }
      return 0;
    });
    this.updateDisplayedCustomers(true);
  }

  handlerProgressSort() {
    if (this.progressSortStatus === 'asc') {
      this.progressSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.progressCount || a.progressCount > b.progressCount) {
          return -1;
        }
        if (a.progressCount < b.progressCount) {
          return 1;
        }
        return 0;
      });
      this.updateDisplayedCustomers(true);
      return;
    }

    this.progressSortStatus = 'asc';
    this.customers.sort((a, b) => {
      if (!a.progressCount || a.progressCount < b.progressCount) {
        return -1;
      }
      if (a.progressCount > b.progressCount) {
        return 1;
      }
      return 0;
    });
    this.updateDisplayedCustomers(true);
  }

  handlerGraduateYearSort() {
    if (this.graduateYearSortStatus === 'asc') {
      this.graduateYearSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (
          !b.dynamicData.academicHistory1.graduateYear ||
          a.dynamicData.academicHistory1.graduateYear > b.dynamicData.academicHistory1.graduateYear
        ) {
          return -1;
        }
        if (a.dynamicData.academicHistory1.graduateYear < b.dynamicData.academicHistory1.graduateYear) {
          return 1;
        }
        return 0;
      });
      this.updateDisplayedCustomers(true);
      return;
    }

    this.graduateYearSortStatus = 'asc';
    this.customers.sort((a, b) => {
      if (
        !a.dynamicData.academicHistory1.graduateYear ||
        a.dynamicData.academicHistory1.graduateYear < b.dynamicData.academicHistory1.graduateYear
      ) {
        return -1;
      }
      if (a.dynamicData.academicHistory1.graduateYear > b.dynamicData.academicHistory1.graduateYear) {
        return 1;
      }
      return 0;
    });
    this.updateDisplayedCustomers(true);
  }

  handlerYomi3Sort(yomi3Key: Yomi3Target) {
    const yomi3SortDataMapping = {
      [Yomi3Target.passed]: {
        sortStatusRefKey: 'yomi3PassedSortStatus',
        dropdownDataListRefKey: 'yomi3PassedDropdownData',
        sortValueKey: 'p_yomi_3_passed'
      },
      [Yomi3Target.inclination]: {
        sortStatusRefKey: 'yomi3InclinationSortStatus',
        dropdownDataListRefKey: 'yomi3InclinationDropdownData',
        sortValueKey: 'p_yomi_3_inclination'
      },
      [Yomi3Target.schedule]: {
        sortStatusRefKey: 'yomi3ScheduleSortStatus',
        dropdownDataListRefKey: 'yomi3ScheduleDropdownData',
        sortValueKey: 'p_yomi_3_schedule'
      }
    };
    const sortData = yomi3SortDataMapping[yomi3Key];
    if(!sortData) {
      throw new Error(`${yomi3Key} sort not defined`);
    }
    const {
      sortStatusRefKey,
      dropdownDataListRefKey,
      sortValueKey
    } = sortData;

    const dropdownDataListRef = this[dropdownDataListRefKey];

    if (this[sortStatusRefKey] === 'asc') {
      this[sortStatusRefKey] = 'desc';

      this.customers.sort((a, b) => {
        const companyProgressDataForA = this.customersExpectedCompanyMapping[a.id];
        const companyProgressDataForB = this.customersExpectedCompanyMapping[b.id];

        // companyProgressData の dynamicData.yomi3Passed の値 が this.yomi3PassedDropdownData の要素 :{value: string} の value と一致する index が小さい順にソートする
        const getIndex = (v) => {
          const i = dropdownDataListRef.filter(t => t.value).findIndex(t => t && t.value === v);
          return i === -1 ? Number.POSITIVE_INFINITY : i;
        };
        const idxA = getIndex(companyProgressDataForA[sortValueKey]);
        const idxB = getIndex(companyProgressDataForB[sortValueKey]);
        return idxA - idxB;
      });
    } else {
      this[sortStatusRefKey] = 'asc';
      this.customers.sort((a, b) => {
        const companyProgressDataForA = this.customersExpectedCompanyMapping[a.id];
        const companyProgressDataForB = this.customersExpectedCompanyMapping[b.id];
        // companyProgressData の dynamicData.yomi3Passed の値 が this.yomi3PassedDropdownData の要素 :{value: string} の value と一致する index が大きい順にソートする
        const getIndex = (v) => {
          const i = dropdownDataListRef.filter(t => t.value).findIndex(t => t && t.value === v);
          return i === -1 ? Number.POSITIVE_INFINITY : i;
        };
        const idxA = getIndex(companyProgressDataForA[sortValueKey]);
        const idxB = getIndex(companyProgressDataForB[sortValueKey]);
        return idxB - idxA;
      });
    }
    this.updateDisplayedCustomers(true);
  }

  handlerSfSort() {
    if (this.sfSortStatus === 'asc') {
      this.sfSortStatus = 'desc';

      this.customers.sort((a, b) => {
        if (!b.dynamicData.rank || a.dynamicData.rank > b.dynamicData.rank) {
          return -1;
        }
        if (a.dynamicData.rank < b.dynamicData.rank) {
          return 1;
        }
        return 0;
      });
      this.updateDisplayedCustomers(true);
      return;
    }

    this.sfSortStatus = 'asc';
    this.customers.sort((a, b) => {
      if (!a.dynamicData.rank || a.dynamicData.rank < b.dynamicData.rank) {
        return -1;
      }
      if (a.dynamicData.rank > b.dynamicData.rank) {
        return 1;
      }
      return 0;
    });
    this.updateDisplayedCustomers(true);
  }

  handlerPickUpMemoRegisterSort() {
    if (this.pickUpMemoRegisterSortStatus === 'asc') {
      this.pickUpMemoRegisterSortStatus = 'desc';

      this.customers.sort((a, b) => {
        const aPick = this.pickUpMemo[a.id];
        const bPick = this.pickUpMemo[b.id];
        // console.log('aPick', aPick);
        // console.log('bPick', bPick);

        if (!aPick && !bPick) {
          return 0;
        }
        if (aPick === bPick) {
          return 0;
        }
        if (!bPick || !bPick.registerDate || (aPick && aPick.registerDate > bPick.registerDate)) {
          return -1;
        }
        return 1;
      });
      this.updateDisplayedCustomers(true);
      return;
    }

    this.pickUpMemoRegisterSortStatus = 'asc';
    this.customers.sort((a, b) => {
      const aPick = this.pickUpMemo[a.id];
      const bPick = this.pickUpMemo[b.id];

      if (!aPick && !bPick) {
        return 0;
      }
      if (aPick === bPick) {
        return 0;
      }
      if (!aPick || !aPick.registerDate || (bPick && aPick.registerDate < bPick.registerDate)) {
        return -1;
      }
      return 1;
    });
    this.updateDisplayedCustomers(true);
  }

  handleSaveMyMonthlySalesOverviewForTargetMonth() {
    this.expectedCompanyYomiService.handleSaveMyMonthlySalesOverviewForTargetMonth(
      this.selectedExpectedContractMonthValue,
      this.salesSummaryForUserModel
    ).subscribe(() => {
      //
    });
  }

  private buildApiFilterParams(conditions: CustomerFilterCondition[]): Record<string, any> {
    const params: Record<string, any> = {};
    for (const condition of conditions) {
      if (condition.value === null || condition.value === undefined || condition.value === '') continue;
      switch (condition.key) {
        case 'userName':
          params['caUserIds'] = [Number(condition.value)];
          break;
        case 'yomi':
          params['yomi'] = String(condition.value);
          break;
        case 'activeCount':
          params['activeCountFrom'] = String(condition.value);
          params['activeCountTo'] = String(condition.value);
          break;
        case 'progressCount':
          params['progressCountFrom'] = String(condition.value);
          params['progressCountTo'] = String(condition.value);
          break;
        case 'sf':
          params['rank'] = [String(condition.value)];
          break;
        case 'graduateYear':
          params['graduateYear'] = [String(condition.value)];
          break;
        case 'yomi3Passed':
          params['yomi3PassedFilter'] = String(condition.value);
          break;
        case 'yomi3Inclination':
          params['yomi3InclinationFilter'] = String(condition.value);
          break;
        case 'yomi3Schedule':
          params['yomi3ScheduleFilter'] = String(condition.value);
          break;
      }
    }
    return params;
  }

  private makeDropdownOptions(data: Array<{ label: string; value: string | null }>): CustomerFilterOption[] {
    return (data || [])
      .filter((item): item is { label: string; value: string } => !!item.value)
      .map((item) => ({
        label: item.label,
        value: item.value,
      }));
  }

  private buildSelectOptions(values: string[]): CustomerFilterOption[] {
    return Array.from(new Set(values)).map((value) => ({
      label: value,
      value,
    }));
  }

  get pageRangeStart(): number {
    if (this.totalFilteredCount === 0) {
      return 0;
    }
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get pageRangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalFilteredCount);
  }

  get totalPages(): number {
    return Math.ceil(this.totalFilteredCount / this.pageSize);
  }

  get pageNumbers(): (number | string)[] {
    const total = this.totalPages;
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages: (number | string)[] = [];
    if (this.currentPage <= 4) {
      for (let i = 1; i <= 5; i++) { pages.push(i); }
      pages.push('...');
      pages.push(total);
    } else if (this.currentPage >= total - 3) {
      pages.push(1);
      pages.push('...');
      for (let i = total - 4; i <= total; i++) { pages.push(i); }
    } else {
      pages.push(1);
      pages.push('...');
      pages.push(this.currentPage - 1);
      pages.push(this.currentPage);
      pages.push(this.currentPage + 1);
      pages.push('...');
      pages.push(total);
    }
    return pages;
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    this.updateDisplayedCustomers();
  }

  private updateDisplayedCustomers(resetPage = false): void {
    if (resetPage) {
      this.currentPage = 1;
    }
    this.totalFilteredCount = this.customers.length;
    const start = (this.currentPage - 1) * this.pageSize;
    this.displayedCustomers = this.customers.slice(start, start + this.pageSize);
  }

  private compareUserNameOrder(a: Student, b: Student): number {
    const aUserName = this.getCaUserName(a);
    const bUserName = this.getCaUserName(b);
    return aUserName.localeCompare(bUserName, 'ja');
  }

  private getCaUserName(student: Student): string {
    const userId = student && student.studentUser && student.studentUser[0]
      ? student.studentUser[0].userId
      : null;
    return userId != null ? (this.userNameMap[userId] || '') : '';
  }

  private compareYomiOrder(aYomi?: string, bYomi?: string): number {
    const yomiOrder = [
      'カタ',
      'FCST',
      '★',
      'ノビ',
      'マイナスカタ',
      'マイナスFCST',
      'マイナス★',
      'マイナスノビ',
    ];
    const getIndex = (value?: string) => {
      const index = yomiOrder.indexOf(value || '');
      return index === -1 ? Number.POSITIVE_INFINITY : index;
    };
    const aIndex = getIndex(aYomi);
    const bIndex = getIndex(bYomi);

    if (aIndex < bIndex) {
      return -1;
    }
    if (aIndex > bIndex) {
      return 1;
    }
    return 0;
  }

}
